export const PERMISSIONS = {
  // Leave Summary
  LEAVE_DETAILS_READ: 'LEAVE_DETAILS_READ', // View leave summary/status
  LEAVE_DETAILS_WRITE: 'LEAVE_DETAILS_WRITE', // Apply for leave
  // Dashboard staff allocation
  STAFF_ALLOCATION_READ: 'STAFF_ALLOCATION_READ',
  STAFF_ALLOCATION_WRITE: 'STAFF_ALLOCATION_WRITE',
  // Activities
  ACTIVITY_DETAILS_READ: 'ACTIVITY_DETAILS_READ',
  ACTIVITY_DETAILS_WRITE: 'ACTIVITY_DETAILS_WRITE',
  
  // Events
  EVENT_DETAILS_READ: 'EVENT_DETAILS_READ',
  EVENT_DETAILS_WRITE: 'EVENT_DETAILS_WRITE',


  // Holidays
  HOLIDAY_DETAILS_READ: 'HOLIDAY_DETAILS_READ',
  HOLIDAY_DETAILS_WRITE: 'HOLIDAY_DETAILS_WRITE',

  HOLIDAY_IMPORTED_DATA_READ: 'HOLIDAY_IMPORTED_DATA_READ',
  HOLIDAY_IMPORTED_DATA_WRITE: 'HOLIDAY_IMPORTED_DATA_WRITE',

  // Location Management
  LOCATION_DETAILS_READ: 'LOCATION_DETAILS_READ',
  LOCATION_DETAILS_WRITE: 'LOCATION_DETAILS_WRITE',

  // Organisation Management
  ORGANISATION_DETAILS_READ: 'ORGANISATION_DETAILS_READ',
  ORGANISATION_DETAILS_WRITE: 'ORGANISATION_DETAILS_WRITE',
  
  GLOBAL_DUTY_MANAGEMENT_READ:'GLOBAL_DUTY_MANAGEMENT_READ',
  GLOBAL_DUTY_MANAGEMENT_WRITE:'GLOBAL_DUTY_MANAGEMENT_WRITE',
  // Shift/Duties

  DUTY_MANAGEMENT_READ: 'DUTY_MANAGEMENT_READ',
  DUTY_MANAGEMENT_WRITE: 'DUTY_MANAGEMENT_WRITE',

  DUTY_PLANNING_ACTIVATION_READ: 'DUTY_PLANNING_ACTIVATION_READ',
  DUTY_PLANNING_ACTIVATION_WRITE: 'DUTY_PLANNING_ACTIVATION_WRITE',

  DUTY_DEPARTMENT_MAPPING_READ: 'DUTY_DEPARTMENT_MAPPING_READ',
  DUTY_DEPARTMENT_MAPPING_WRITE: 'DUTY_DEPARTMENT_MAPPING_WRITE',
  // Staff/Team
  // Non-global Feature

 // Basic Information
  STAFF_BASIC_INFORMATION_READ: 'STAFF_BASIC_INFORMATION_READ',
  STAFF_BASIC_INFORMATION_WRITE: 'STAFF_BASIC_INFORMATION_WRITE',

 // Employment Details
  STAFF_EMPLOYMENT_DETAILS_READ: 'STAFF_EMPLOYMENT_DETAILS_READ',
  STAFF_EMPLOYMENT_DETAILS_WRITE: 'STAFF_EMPLOYMENT_DETAILS_WRITE',

 // Configuration Details
  STAFF_CONFIGURATION_DETAILS_READ: 'STAFF_CONFIGURATION_DETAILS_READ',
  STAFF_CONFIGURATION_DETAILS_WRITE: 'STAFF_CONFIGURATION_DETAILS_WRITE',


  // User Profile
  PROFILE_DETAILS_READ: 'PROFILE_DETAILS_READ',
  PROFILE_DETAILS_WRITE: 'PROFILE_DETAILS_WRITE',

  // Global Feature
  // Basic Information
  GLOBAL_STAFF_BASIC_INFORMATION_READ: 'GLOBAL_STAFF_BASIC_INFORMATION_READ',
  GLOBAL_STAFF_BASIC_INFORMATION_WRITE: 'GLOBAL_STAFF_BASIC_INFORMATION_WRITE',

// Employment Details
  GLOBAL_STAFF_EMPLOYMENT_DETAILS_READ: 'GLOBAL_STAFF_EMPLOYMENT_DETAILS_READ',
  GLOBAL_STAFF_EMPLOYMENT_DETAILS_WRITE: 'GLOBAL_STAFF_EMPLOYMENT_DETAILS_WRITE',

  // Configuration Details
  GLOBAL_STAFF_CONFIGURATION_DETAILS_READ: 'GLOBAL_STAFF_CONFIGURATION_DETAILS_READ',
  GLOBAL_STAFF_CONFIGURATION_DETAILS_WRITE: 'GLOBAL_STAFF_CONFIGURATION_DETAILS_WRITE',

  
  // Planning Sheet
  PLANNING_SHEET_READ: 'PLANNING_SHEET_READ',
  PLANNING_SHEET_WRITE: 'PLANNING_SHEET_WRITE',

  // Stream Management
  STREAM_MANAGEMENT_READ: 'STREAM_MANAGEMENT_READ',
  STREAM_MANAGEMENT_WRITE: 'STREAM_MANAGEMENT_WRITE',
    // Chat management
  CHAT_CONFIGURATION_READ:'CHAT_CONFIGURATION_READ',
  CHAT_CONFIGURATION_WRITE:'CHAT_CONFIGURATION_WRITE',

  // For managing group level actions
  CHAT_GROUP_CONFIGURATION_READ:'CHAT_GROUP_CONFIGURATION_READ',
  CHAT_GROUP_CONFIGURATION_WRITE:'CHAT_GROUP_CONFIGURATION_WRITE',
  // Post Management
  // POST_MANAGEMENT_READ: 'POST_MANAGEMENT_READ',
  // POST_MANAGEMENT_WRITE: 'POST_MANAGEMENT_WRITE',

  //Permission for planning manager sheet
  MANAGER_PLANNING_SHEET_READ: 'MANAGER_PLANNING_SHEET_READ',
  MANAGER_PLANNING_SHEET_WRITE: 'MANAGER_PLANNING_SHEET_WRITE',
  
  // Permission for multidepartment view in planning sheet
  MULTIDEPARTMENT_PLANNING_READ: 'MULTIDEPARTMENT_PLANNING_READ',
  MULTIDEPARTMENT_PLANNING_WRITE: 'MULTIDEPARTMENT_PLANNING_WRITE',
  // ************for mobile***************

  // Time Difference management
  TIME_DIFFERENCE_READ: 'TIME_DIFFERENCE_READ',
  TIME_DIFFERENCE_WRITE: 'TIME_DIFFERENCE_WRITE',

  LEAVE_REQUEST_READ: 'LEAVE_REQUEST_READ',
  LEAVE_REQUEST_WRITE: 'LEAVE_REQUEST_WRITE',

  DUTY_PREPLANNING_READ: 'DUTY_PREPLANNING_READ',//for handling wished duty
  DUTY_PREPLANNING_WRITE: 'DUTY_PREPLANNING_WRITE',

  // Swap request by user
  SWAP_REQUEST_READ: 'SWAP_REQUEST_READ', //Permission for user to view their swap request summary
  SWAP_REQUEST_WRITE: 'SWAP_REQUEST_WRITE', //Permission for user to apply for swap

  USER_PROFILE_READ: 'USER_PROFILE_READ', //Permission for user to view their profile
  USER_PROFILE_WRITE: 'USER_PROFILE_WRITE', //Permission for user to update their profile

  STREAM_DATA_READ: 'STREAM_DATA_READ', //Permission for user to view stream data
  STREAM_DATA_WRITE: 'STREAM_DATA_WRITE', //Permission for user to update stream data

  // POST_DATA_READ: 'POST_DATA_READ', //Permission for user to view post data
  // POST_DATA_WRITE: 'POST_DATA_WRITE', //Permission for user to update post data

  DUTY_ALLOCATION_READ: 'DUTY_ALLOCATION_READ', //Permission for user to view duty allocation
  DUTY_ALLOCATION_WRITE: 'DUTY_ALLOCATION_WRITE', //Permission for user
  // Chat management
  CHAT_DATA_READ:'CHAT_DATA_READ',
  CHAT_DATA_WRITE:'CHAT_DATA_WRITE',

  // For managing group level actions
  CHAT_GROUP_MANAGEMENT_READ:'CHAT_GROUP_MANAGEMENT_READ',
  CHAT_GROUP_MANAGEMENT_WRITE:'CHAT_GROUP_MANAGEMENT_WRITE',

  //Permission for PDF documents read/write in mobile app
  DOCUMENT_DATA_READ:'DOCUMENT_DATA_READ',
  DOCUMENT_DATA_WRITE:'DOCUMENT_DATA_WRITE',

  //Permission for feedback read/write
  FEEDBACK_DATA_READ:'FEEDBACK_DATA_READ',
  FEEDBACK_DATA_WRITE:'FEEDBACK_DATA_WRITE',

  ALLOWANCE_MONTHLY_EXPORT_READ: 'ALLOWANCE_MONTHLY_EXPORT_READ',
  ALLOWANCE_MONTHLY_EXPORT_WRITE: 'ALLOWANCE_MONTHLY_EXPORT_WRITE',

};